var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var isLocalHost = function () {
    var _a;
    if (typeof window === "undefined")
        return false;
    var host = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    return host === "localhost" || host === "127.0.0.1";
};
/**
 * Validates data against a Zod schema using `safeParse`, and logs each error to the console
 * only when validation fails and in local development environment.
 *
 * @template S - The Zod Schema Type
 * @template T - The inferred return type from the schema
 * @param schema - The Zod Schema to validate against
 * @param data - The data to validate
 * @param title - Optional title to label the log by.
 * @returns  The `SafeParesReturnType` containing either `success: true` and the parsed data
 * or `success: false` and the errors.
 */
export var parseOrLog = function (schema, data, title) {
    var _a, _b, _c, _d;
    if (title === void 0) { title = ""; }
    var result = schema.safeParse(data);
    if (!result.success && isLocalHost()) {
        (_a = console.groupCollapsed) === null || _a === void 0 ? void 0 : _a.call(console, "ZOD Error ~ ".concat(title, ": "));
        (_c = (_b = result === null || result === void 0 ? void 0 : result.error) === null || _b === void 0 ? void 0 : _b.issues) === null || _c === void 0 ? void 0 : _c.forEach(function (issue) {
            return console.error("\u274C ".concat(issue.path.join("."), " ~ ").concat(issue.message));
        });
        (_d = console.groupEnd) === null || _d === void 0 ? void 0 : _d.call(console);
    }
    return result;
};
/**
 * Asynchronously validates data against a Zod schema using `safeParseAsync`, and logs each error to the console
 * only when validation fails and in local development environment.
 *
 * @template S - The Zod Schema Type
 * @template T - The inferred return type from the schema
 * @param schema - The Zod Schema to validate against
 * @param data - The data to validate
 * @param title - Optional title to label the log by.
 * @returns  A promise resolving to the `SafeParseReturnType` object
 */
export var parseOrLogAsync = function (schema, data, title) {
    if (title === void 0) { title = ""; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, schema.safeParseAsync(data)];
                case 1:
                    result = _e.sent();
                    if (!result.success && isLocalHost()) {
                        (_a = console.groupCollapsed) === null || _a === void 0 ? void 0 : _a.call(console, "ZOD Error ~ ".concat(title, ": "));
                        (_c = (_b = result === null || result === void 0 ? void 0 : result.error) === null || _b === void 0 ? void 0 : _b.issues) === null || _c === void 0 ? void 0 : _c.forEach(function (issue) {
                            return console.error("\u274C ".concat(issue.path.join("."), " ~ ").concat(issue.message));
                        });
                        (_d = console.groupEnd) === null || _d === void 0 ? void 0 : _d.call(console);
                    }
                    return [2 /*return*/, result];
            }
        });
    });
};
